// extracted by mini-css-extract-plugin
module.exports = {"gifImage":"HeatmapsUpsellModal_gifImage__XPO_H"};